<div fxLayout="row" class="background">
    <div fxFlex="95" fxFlexOffset="2%">

        <section id="header">
            <h1 class="h1Header">REPORTE DE VENTAS</h1>
        </section>

        <form [formGroup]="salesReportsForm" >
            <div class="formulario">
              <mat-card>
                <div fxLayout="row" fxLayoutAlign="space-evenly center">
                  <div fxFlex="15">
                    <mat-form-field appearance="outline">
                      <mat-label>Fecha Desde</mat-label>
                        <input (dateInput)="inputDateFrom($event)" matInput [matDatepicker]="calendar" formControlName="fechaD" readonly
                          format="yyyy-MM-dd">
                        <mat-datepicker-toggle matSuffix [for]="calendar"></mat-datepicker-toggle>
                        <mat-datepicker #calendar></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field appearance="outline">
                      <mat-label>Fecha Hasta</mat-label>
                        <input (dateInput)="inputDateTo($event)" matInput [matDatepicker]="fhasta" formControlName="fechaH" readonly
                        format="yyyy-MM-dd">
                        <mat-datepicker-toggle matSuffix [for]="fhasta"></mat-datepicker-toggle>
                        <mat-datepicker #fhasta></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                     <mat-form-field appearance="outline">
                      <mat-label>Comercio</mat-label>
                      <mat-select formControlName="comercio">
                        <mat-option value="0">Todos</mat-option>
                        <mat-option *ngFor="let store of storeOptions" [value]="store.cdStore">{{store.dsName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field appearance="outline">
                      <mat-label>Estado</mat-label>
                      <mat-select formControlName="estado">
                        <mat-option *ngFor="let status of statusOptions" [value]="status.value">{{status.viewValue}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field appearance="outline">
                      <mat-label>Liq.</mat-label>
                      <mat-select formControlName="liq">
                        <mat-option *ngFor="let liq of liquidationOption" [value]="liq.value">{{liq.viewValue}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-evenly center">
                    <button fxFlex="20" mat-raised-button class="squared-btn"
                       (click)="previewReport(salesReportsForm.value)">Previsualizar</button>
                    <button fxFlex="20" mat-raised-button class="squared-btn" 
                       (click)="exporter.exportTable('xlsx')">Exportar Excel</button>
                    <button fxFlex="20" mat-raised-button class="squared-btn"
                       (click)="exportPDF()">Exportar PDF</button>
                </div>
            </mat-card>
        </div>
        </form>

        <div fxLayout="row">
            <div fxFlex=100>
              <mat-card class="mat-elevation-z0" >
                <table mat-table matTableExporter [dataSource]="salesReports" id="report" #exporter="matTableExporter" class="tabla">
                 
                  <!-- idC Column -->
                  <ng-container matColumnDef="idC">
                    <th mat-header-cell *matHeaderCellDef class="table-header"> ID_COM. </th>
                    <td mat-cell *matCellDef="let element" class="table-content"> {{element.cdStore}}</td>
                  </ng-container>
          
                  <!-- comercio Column -->
                  <ng-container matColumnDef="comercio">
                    <th mat-header-cell *matHeaderCellDef class="table-header"> COMERCIO</th>
                    <td mat-cell *matCellDef="let element" class="table-content"> {{element.dsName}} </td>
                  </ng-container>

                   <!-- idP Column -->
                   <ng-container matColumnDef="idP">
                    <th mat-header-cell *matHeaderCellDef class="table-header"> ID_PEDIDO </th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.cdOrder}}</td>
                  </ng-container>
          
                  <!-- fechaP Column -->
                  <ng-container matColumnDef="fechaP">
                    <th mat-header-cell *matHeaderCellDef class="table-header"> FECHA PEDIDO </th>
                    <td mat-cell *matCellDef="let element" class="table-content"> {{element.dtCreatedAt | date: 'short'}} </td>
                  </ng-container>
          
                  <!-- nombreCli Column -->
                  <ng-container matColumnDef="nombreCli">
                    <th mat-header-cell *matHeaderCellDef class="table-header"> CLIENTE</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.dsUserName}}</td>
          
                  </ng-container>
                  
                   <!-- telCli Column -->
                   <ng-container matColumnDef="telCli">
                    <th mat-header-cell *matHeaderCellDef class="table-header"> TEL. CLIENTE</th>
                    <td mat-cell *matCellDef="let element" class="table-content"> {{element.dsPhone}} </td>
                  </ng-container>

                  <!-- dirCli Column -->
          
                  <ng-container matColumnDef="dirCli">
                    <th mat-header-cell *matHeaderCellDef class="table-header">DIR. CLIENTE</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.dsAddress}}</td>
                  </ng-container>
          
                  <!-- envio Column -->
          
                  <ng-container matColumnDef="envio">
                    <th mat-header-cell *matHeaderCellDef class="table-header">ENVÍO</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.qtDCharges}}</td>
                  </ng-container>

                  <!-- desc Column -->
          
                  <ng-container matColumnDef="desc">
                    <th mat-header-cell *matHeaderCellDef class="table-header">DESC</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.qtDiscount}}</td>
                  </ng-container>

                  <!-- total Column -->
          
                  <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.qtTotal}}</td>     
                  </ng-container>

                  <!-- estado Column -->
          
                  <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.nmStatus| ordersStatus}}</td>     
                  </ng-container>

                  <!-- comision Column -->
          
                  <ng-container matColumnDef="comision">
                    <th mat-header-cell *matHeaderCellDef class="table-header">COMISIÓN</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.qtComision}}</td>    
                  </ng-container>

                  <!-- liquidacion Column -->
          
                  <!-- <ng-container matColumnDef="liquidacion">
                    <th mat-header-cell *matHeaderCellDef class="table-header">LIQ.</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.liquidacion}}</td>  
                  </ng-container> -->

                  <!--nombreCad Column -->
          
                  <!-- <ng-container matColumnDef="nombreCad">
                    <th mat-header-cell *matHeaderCellDef class="table-header">CADETE</th>
                    <td mat-cell *matCellDef="let element" class="table-content">{{element.nombreCad}}</td>   
                  </ng-container> -->
          
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          
                </table>
                <br>
                <mat-card fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="1rem">
                  <span>Cantidad de pedidos: {{totalRows}} </span>
                  <span>Total: ${{getTotal() | number: '1.2-2'}}</span>
                   <span>Total Comisión: ${{getTotalComision() | number: '1.2-2'}}</span>
                  <!--<span>Total a liquidar: ${{getTotalLiquidation() | number: '1.2-2'}}</span> -->
              </mat-card>
              </mat-card>
            </div>
        </div>

    </div>
</div>